'use strict';

var _ = require('../mindash');

module.exports = function (marty, React) {
  _.extend(marty, require('./createContainer')(React));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/container/index.js
// module id = IKFG
// module chunks = 88